module.exports = __webpack_public_path__ + "img/Nebbia.911d7744.jpg";